import React, { useState } from "react";
import { Modal } from "antd";

export default function RenameDialog({ umbrella, onSave, onClose }) {
  const [name, setName] = useState(umbrella.name);
  return (
    <Modal open title={`Rename ${umbrella.name}`} onCancel={onClose} footer={null} destroyOnClose>
      <label className="umb-label" htmlFor="umb-new-name">New name</label>
      <input id="umb-new-name" className="form-control" value={name} onChange={(event) => setName(event.target.value)} />
      <div className="umb-dialog-buttons">
        <button type="button" className="btn btn-light" onClick={onClose}>Cancel</button>
        <button type="button" className="btn btn-primary" disabled={!name.trim()} onClick={() => onSave(name.trim())}>
          Save name
        </button>
      </div>
    </Modal>
  );
}
